import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BrandEntrance } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '@shared/image/image/image.component';
import { SpotHeadlineComponent } from '../spot-headline/spot-headline.component';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-brand-entrance',
    templateUrl: './brand-entrance.component.html',
    styleUrls: ['./brand-entrance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, SpotHeadlineComponent, NgFor, NgClass, ImageComponent, RouterLink]
})
export class BrandEntranceComponent {
    public static readonly ref: string = 'brandEntrances';

    @Input()
    public data: BrandEntrance;
}
